<template>
  <div>
    <b-badge
      :variant="fishbowlStatus.color"
      v-html="showNumber ? order.salesOrderNumber : fishbowlStatus.badge "
      v-b-popover.hover="`SO: ${order.soStatus}/Pick: ${order.pickStatus}/Ship: ${order.shipStatus}/Items: ${order.itemStatus}`"
    >
    </b-badge>
    <b-alert
      show
      variant="warning"
      v-if="fishbowlStatus.warning && showWarning"
    >
      {{ fishbowlStatus.warning }}
    </b-alert>
  </div>
</template>

<script>
import Constants from '../../../constants.js';
import FishbowlService from '../../services/fishbowl.js';
import axios from 'axios';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  name: 'FishbowlStatus',
  data() {
    return {
      myOrder: {},
      triedReload: false,
    }
  },
  props: {
    order: Object,
    showWarning: { type: Boolean, default: true },
    showNumber: { type: Boolean, default: false },
    tryReload: { type: Boolean, default: false },
  },
  methods: {
    fetchOrder(order) {
      if(!this.order.exists && this.order.soNum && this.tryReload && !this.triedReload) {
        let vm = this;
        this.triedReload = true;
        FishbowlService.getSimpleSalesOrder(this.order.soNum).then( r => {
          this.myOrder = r;
          vm.$emit('update-fishbowl-order', r);
          return this.fishbowlStatus;
        });
      }
    }
  },
  computed: {
    realOrder() {
      return Object.keys(this.myOrder).length > 0 ? this.myOrder : this.order;
    },
    fishbowlStatus() {
      const status = {
        badge: '???',
        color: 'secondary',
      };
      if(!this.realOrder.exists && (this.realOrder.soNum || this.order.soNum) && this.tryReload) {
        if(this.triedReload) {
          status.badge = 'Not in FB';
          return status;
        } else {
          status.badge = '<i class="fas fa-spinner fa-spin"></i>';
          this.fetchOrder(this.order);
          return status;
        }
      }

      if(!this.realOrder.soStatus) {
        status.badge = 'Not in FB'
        return status;
      }

      const so = this.realOrder.soStatus;
      let pi = this.realOrder.pickStatus ? this.realOrder.pickStatus : [];
      let sh = this.realOrder.shipStatus ? this.realOrder.shipStatus : [];
      let is = this.realOrder.itemStatus ? this.realOrder.itemStatus : [];

      if (so == Constants.SO_STATUS_ESTIMATE) {
        status.badge = 'Estimate';
      }

      if (so == Constants.SO_STATUS_ISSUED) {
        status.badge = 'Issued';
        status.color = 'success';

        if (pi.includes(Constants.PICK_STATUS_STARTED)) {
          status.badge = 'Picking';
          status.color = 'info';
        }
      }

      if (so == Constants.SO_STATUS_IN_PROGRESS) {
        if (pi.includes(Constants.PICK_STATUS_ENTERED)) {
          status.color = 'primary';

          if (sh.includes(Constants.SHIP_STATUS_PACKED)) {
            status.badge = 'Packed - Partial';
          }

          if (sh.includes(Constants.SHIP_STATUS_ENTERED)) {
            status.badge = 'Packing - Partial';
            if (Date.now() - (24 * 60 * 60) < Date.parse(this.order.shipCreate)) {
              status.warning = 'Shipment created more than a day ago!';
            }
          }

          if (sh.includes(Constants.SHIP_STATUS_SHIPPED)) {
            status.badge = 'Partial Backorder';
            status.color = 'dark';
          }
        } else if (pi.includes(Constants.PICK_STATUS_STARTED)) {
          status.color = 'primary';

          if (sh.count == 0) {
            status.badge = 'Picking';
            if (Date.now() - (5 * 60) < Date.parse(this.order.pickStart)) {
              status.warning = 'Picking started more than 5 minutes ago!';
            }
          }

          if (sh.includes(Constants.SHIP_STATUS_PACKED)) {
            status.badge = 'Picking + Packed';
            status.warning = 'Should find both shipments and combine';
          }

          if (sh.includes(Constants.SHIP_STATUS_ENTERED)) {
            status.badge = 'Picking + Packing';
          }

          if (sh.includes(Constants.SHIP_STATUS_SHIPPED)) {
            status.badge = 'Picking Backordered Items';
            status.color = 'dark';
            status.warning = 'May cause issues when packing second order!';
          }
        } else if (pi.includes(Constants.PICK_STATUS_COMMITTED)) {
          status.color = 'primary';

          if (sh.length == 0) {
            status.badge = 'Picking';
            if (Date.now() - (24 * 60 * 60) < Date.parse(this.order.pickStart)) {
              status.warning = 'Picking started more than a day ago!';
            }
          }

          if (sh.includes(Constants.SHIP_STATUS_PACKED)) {
            status.badge = 'Partially Shipping Today';
            status.color = 'success';
          }

          if (sh.includes(Constants.SHIP_STATUS_ENTERED)) {
            status.badge = 'Packing Backordered Items';
            status.color = 'dark';
          }

          if (sh.includes(Constants.SHIP_STATUS_SHIPPED)) {
            status.badge = 'Picking Backordered Items';
            status.color = 'dark';
          }
        } else if (pi.includes(Constants.PICK_STATUS_FINISHED)) {
          if (sh.includes(Constants.SHIP_STATUS_PACKED)) {
            status.badge = 'Shipping Today';
            status.color = 'success';
          }

          if (sh.includes(Constants.SHIP_STATUS_ENTERED)) {
            status.badge = 'Packing';
            status.color = 'primary';
          }
        }
      }

      if (so == Constants.SO_STATUS_FULFILLED) {
        status.badge = 'Fulfilled & Shipped';
        status.color = 'success';
      }

      if (so == Constants.SO_STATUS_CLOSED) {
        status.badge = 'Closed Short';
        status.color = 'warning';
      }

      if (so == Constants.SO_STATUS_VOIDED) {
        status.badge = 'Voided';
        status.color = 'danger';
      }

      if (so == Constants.SO_STATUS_EXPIRED) {
        status.badge = 'Expired';
        status.color = 'danger';
      }

      if (is.includes(Constants.PICK_ITEM_STATUS_SHORT) || is.includes(Constants.PICK_ITEM_STATUS_HOLD)) {
        status.color = 'dark';
        if (!status.badge.includes('Backorder')) {
          status.badge += ' / Backorder';
        }
      }

      return status;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/utility/FishbowlStatus.vue